import gql from 'graphql-tag';
import { COLOR_BATCH_PREVIEW_FIELDS } from '../query/query';

// Delete senders / admin / name
const CLEAR_BOX = gql`
  mutation savClearBox($boxId: String) {
    savClearBox(boxId: $boxId)
  }
`;

const DELETE_DUPLICATED_BOX = gql`
  mutation savDeleteDuplicatedBox($pairing: String) {
    savDeleteDuplicatedBox(pairing: $pairing)
  }
`;

const MODERATE_STICKER = gql`
  mutation savModerateSticker($stickerId: String!, $accept: Boolean!) {
    savModerateSticker(stickerId: $stickerId, accept: $accept)
  }
`;

const MODERATE_GIF = gql`
  mutation savModerateGif($gifId: String, $accept: Boolean) {
    savModerateGif(gifId: $gifId, accept: $accept)
  }
`;

const ACCEPT_ALL_GIFS = gql`
  mutation savAcceptAllGifs {
    savAcceptAllGifs
  }
`;

const RESET_USER_PASSWORD = gql`
  mutation savResetUserPassword($email: String) {
    savResetUserPassword(email: $email)
  }
`;

const GIVE_FREE_LBE = gql`
mutation giveFreeLBE($email: String) {
  giveFreeLBE(email: $email)
}
`;

const GIVE_LOVECOINS = gql`
mutation giveLovecoins($email: String, $amount: Int) {
  giveLovecoins(email: $email, amount: $amount)
}
`;

const SET_GIF_RANK = gql`
  mutation setGifRank($gifId: String, $rank: Float) {
    setGifRank(gifId: $gifId, rank: $rank)
  }
`;

const SET_GIF_DESIGNER_RANK = gql`
  mutation setGifDesignerRank($gifId: String, $designerRank: Float) {
    setGifDesignerRank(gifId: $gifId, designerRank: $designerRank)
  }
`;

const SET_GIF_AUTO_RELEASE_DATE = gql`
  mutation setGifAutoReleaseDate($gifId: String, $date: Date) {
    setGifAutoReleaseDate(gifId: $gifId, date: $date)
  }
`;

const GET_DISCOUNT_CODE = gql`
  mutation savCreateDiscountCode($discount: Int, $store: String) {
    savCreateDiscountCode(discount: $discount, store: $store)
  }
`;

const REFRESH_PAIRING_CODE = gql`
mutation savRefreshPairingCode($boxId: String) {
  savRefreshPairingCode(boxId: $boxId)
}
`;

const DELETE_SENDERS = gql`
mutation savDeleteSenders($boxId: String) {
  savDeleteSenders(boxId: $boxId)
}
`;

const DELETE_SENDER = gql`
mutation savDeleteSender($boxId: String, $senderEmail: String) {
  savDeleteSender(boxId: $boxId, senderEmail: $senderEmail)
}
`;

const GET_FREE_HEART_CODE = gql`
  mutation savCreateFreeHeartCode($store: String) {
    savCreateFreeHeartCode(store: $store)
  }
`;

const DELETE_USER = gql`
  mutation savDeleteUser($email: String!) {
    savDeleteUser(email: $email)
  }
`;

const SEND_IMAGE_TO_LOVEPIX = gql`
  mutation savSendImageToLovepix($macAddress: String, $frames: [String], $isPhoto: Boolean, $date: Date) {
    savSendImageToLovepix(macAddress: $macAddress, frames: $frames, isPhoto: $isPhoto, date: $date)
  }
`;

const ADD_TEST_BOXES = gql`
  mutation savAddTestBoxes($macAddresses: String!, $testGroupName: String!) {
    savAddTestBoxes(macAddresses: $macAddresses, testGroupName: $testGroupName) {
      _id
      macAddress
      versions {
        currentVersion
        targetVersion
        lastReceivedVersion
        testGroup
      }
    }
  }
`;

const REMOVE_TEST_BOX = gql`
  mutation savRemoveTestBox($macAddress: String!) {
    savRemoveTestBox(macAddress: $macAddress) {
      _id
      macAddress
    }
  }
`;

const SET_TARGET_VERSION_TO_TEST_GROUP = gql`
  mutation savSetTargetVersionToTestGroup($targetVersion: String!, $testGroupName: String!) {
    savSetTargetVersionToTestGroup(targetVersion: $targetVersion, testGroupName: $testGroupName)
  }
`;

const SET_TARGET_VERSION_TO_BOX = gql`
  mutation savSetTargetVersionToBox($targetVersion: String!, $macAddress: String!, $isTestBox: Boolean!) {
    savSetTargetVersionToBox(targetVersion: $targetVersion, macAddress: $macAddress, isTestBox: $isTestBox) {
      _id
    }
  }
`;

const ADD_AMBASSADOR = gql`
  mutation savAddAmbassador($email: String!) {
    savAddAmbassador(email: $email)
  }
`;

const RM_AMBASSADOR = gql`
  mutation savRemoveAmbassador($ambassadorId: String!) {
    savRemoveAmbassador(ambassadorId: $ambassadorId)
  }
`;

const SET_GIF_TAGS = gql`
  mutation savUpdateGif($gifId: String, $tags: [String]) {
    savUpdateGif(gifId: $gifId, tags: $tags) {
      _id
      tags
    }
  }
`;

const CREATE_TAG = gql`
  mutation savCreateTag($titleFr: String!, $titleEn: String!, $rank: Float) {
    savCreateTag(titleFr: $titleFr, titleEn: $titleEn, rank: $rank) {
      _id
      titleFr
      titleEn
      rank
      isActive
    }
  }
`;

const UPDATE_TAG = gql`
  mutation savUpdateTag($tagId: String!, $titleFr: String, $titleEn: String, $rank: Float, $isActive: Boolean) {
    savUpdateTag(tagId: $tagId, titleFr: $titleFr, titleEn: $titleEn, rank: $rank, isActive: $isActive) {
      _id
      titleFr
      titleEn
      rank
      isActive
    }
  }
`;

const DELETE_TAG = gql`
  mutation savRemoveTag($tagId: String!) {
    savRemoveTag(tagId: $tagId) {
      _id
      titleFr
      titleEn
      rank
      isActive
    }
  }
`;

const CREATE_FIRMWARE_RELEASE = gql`
  mutation savCreateFirmwareRelease($version: String!) {
    savCreateFirmwareRelease(version: $version) {
      active
      version
      date
      limit
      updated
      status {
        succeed
        inProgress
        failed
        failedTooManyAttempts
        failedButConnected
        failedMacAddresses
        failedButConnectedMacAddresses
        failedTooManyAttemptsMacAddresses
      }
    }
  }
`;

const DELETE_FIRMWARE_RELEASE = gql`
  mutation savDeleteFirmwareRelease($version: String!) {
    savDeleteFirmwareRelease(version: $version) {
      version
    }
  }
`;

const SET_FIRMWARE_RELEASE_ACTIVE = gql`
  mutation savSetFirmwareReleaseActive($version: String!) {
    savSetFirmwareReleaseActive(version: $version) {
      active
      version
      date
      limit
      updated
      status {
        succeed
        inProgress
        failed
        failedTooManyAttempts
        failedButConnected
        failedMacAddresses
        failedButConnectedMacAddresses
        failedTooManyAttemptsMacAddresses
      }
    }
  }
`;

const SET_FIRMWARE_RELEASE_LIMIT = gql`
  mutation savSetFirmwareReleaseLimit($version: String!, $limit: Int!) {
    savSetFirmwareReleaseLimit(version: $version, limit: $limit) {
      active
      version
      date
      limit
      updated
      status {
        succeed
        inProgress
        failed
        failedTooManyAttempts
        failedButConnected
        failedMacAddresses
        failedButConnectedMacAddresses
        failedTooManyAttemptsMacAddresses
      }
    }
  }
`;

const UPDATE_FIRMWARE_RELEASE_STATUS = gql`
  mutation savUpdateFirmwareReleaseStatus($version: String!) {
    savUpdateFirmwareReleaseStatus(version: $version) {
      active
      version
      date
      limit
      updated
      status {
        succeed
        inProgress
        failed
        failedTooManyAttempts
        failedButConnected
        failedMacAddresses
        failedButConnectedMacAddresses
        failedTooManyAttemptsMacAddresses
      }
    }
  }
`;

const CHECK_COLOR_CODE = gql`
  mutation savCheckColorCode($colorCode: String) {
    savCheckColorCode(colorCode: $colorCode) {
      message
      macAddress
    }
  }
`;

const TOGGLE_COLOR_FEATURE = gql`
  mutation savToggleColorFeature($boxId: String) {
    savToggleColorFeature(boxId: $boxId)
  }
`;

const TOGGLE_CRAZY_HEART_FIRMWARE = gql`
  mutation savToggleCrazyHeartFirmware($boxId: String) {
    savToggleCrazyHeartFirmware(boxId: $boxId)
  }
`;

const SET_FACTORY_SETTINGS_COLOR = gql`
  mutation savSetFactorySettingsColor($color: Boolean!) {
    savSetFactorySettingsColor(color: $color) {
      color
      companyId
      screenType
    }
  }
`;

const SET_FACTORY_SETTINGS_COMPANY_ID = gql`
  mutation savSetFactorySettingsCompanyId($companyId: String) {
    savSetFactorySettingsCompanyId(companyId: $companyId) {
      color
      companyId
      screenType
    }
  }
`;

const SET_FACTORY_SETTINGS_SCREEN_TYPE = gql`
  mutation savSetFactorySettingsScreenType($screenType: String!) {
    savSetFactorySettingsScreenType(screenType: $screenType) {
      color
      companyId
      screenType
    }
  }
`;

const SET_FACTORY_SETTINGS_PCB_VERSION = gql`
  mutation savSetFactorySettingsPcbVersion($pcbVersion: String!) {
    savSetFactorySettingsPcbVersion(pcbVersion: $pcbVersion) {
      pcbVersion
    }
  }
`;

const FACTORY_UNREGISTER_BOXES = gql`
  mutation savFactoryUnregisterBoxes($boxesMAC: [String]!) {
    savFactoryUnregisterBoxes(boxesMAC: $boxesMAC)
  }
`;

const TRANSFER_BOX_HISTORY = gql`
  mutation savTransferBoxHistory($fromBoxMAC: String!, $toBoxMAC: String!) {
    savTransferBoxHistory(fromBoxMAC: $fromBoxMAC, toBoxMAC: $toBoxMAC)
  }
`;

const UPDATE_BOX_ADMIN = gql`
  mutation savUpdateBoxAdmin($boxId: String!, $newAdminEmail: String!) {
    savUpdateBoxAdmin(boxId: $boxId, newAdminEmail: $newAdminEmail)
  }
`;

const DELETE_MESSAGE = gql`
  mutation savDeleteMessage($messageId: String!) {
    savDeleteMessage(messageId: $messageId)
  }
`;

const UPDATE_PRIVACY_POLICY = gql`
  mutation savUpdateMessagesPrivacyPolicy(
      $boxId: String!, $userId: String!, $newPolicy: MessagePrivacyPolicy!
  ) {
      savUpdateMessagesPrivacyPolicy(boxId: $boxId, userId: $userId, newPolicy: $newPolicy)
  }
`;

const CREATE_TEMPLATE = gql`
  mutation savCreateTemplate(
      $template: SavTemplateInput!
  ) {
    savCreateTemplate(template: $template) {
      _id
    }
  }
`;

const CREATE_TEMPLATES = gql`
  mutation savCreateTemplates(
      $templates: [SavTemplateInput!]
  ) {
    savCreateTemplates(templates: $templates) {
      _id
    }
  }
`;

const UPDATE_TEMPLATE = gql`
  mutation savUpdateTemplate($templateId: String!, $updatedTemplate: SavUpdateTemplateInput!) {
    savUpdateTemplate(templateId: $templateId, updatedTemplate: $updatedTemplate) {
      _id
      rank
      releaseDate
      status
      subCategories
      premium
      internalNote
    }
  }
`;

const DELETE_TEMPLATE = gql`
  mutation savDeleteTemplate($templateId: String!) {
    savDeleteTemplate(templateId: $templateId)
  }
`;

const UPDATE_TEMPLATE_CATEGORIES = gql`
  mutation savUpdateTemplatesCategories($newTemplatesCategories: [SavTemplateCategoryInput!]!) {
    savUpdateTemplatesCategories(newTemplatesCategories: $newTemplatesCategories) {
      _id
      type
      titleFr
      titleEn
      subCategories {
        _id
        type
        titleFr
        titleEn
        hidden
        pinned
        presentation
        isExcludeRandom
      }
    }
  }
`;

const UPDATE_TEMPLATE_CATEGORY = gql`
  mutation savUpdateTemplatesCategory($updatedCategory: SavTemplateCategoryInput!) {
    savUpdateTemplatesCategory(updatedCategory: $updatedCategory) {
      _id
      titleFr
      titleEn
      subCategories {
        _id
        titleFr
        titleEn
        hidden
        pinned
        presentation
        isExcludeRandom
      }
    }
  }
`;

const UPDATE_TEMPLATES_RANK = gql`
  mutation savUpdateTemplatesRank($templates: [SavTemplateInput!]!) {
    savUpdateTemplatesRank(templates: $templates) {
       _id
      background {
        url
      }
      backgroundCover
      elements {
        x
        y
        rotate
        type
        fontSize
        fontFamily
        color
        width
        height
        textAlign
        defaultTextFr
        defaultTextEn
      }
      name
      premium
      releaseDate
      status
      subCategories
      thumbnailFr
      thumbnailEn
      ranks {
        id
        rank
      }
    }
  }
`;

const DELETE_TEMPLATE_CATEGORY = gql`
  mutation savDeleteTemplateCategory($category: SavTemplateCategoryInput, $subCategory: SavTemplateCategoryInput) {
    savDeleteTemplateCategory(category: $category, subCategory: $subCategory)
  }
`;

const UPDATE_SUBSCRIPTION = gql`
  mutation savUpdateSubscription($subscriptionUpdate: SavSubscriptionUpdateInput) {
    savUpdateSubscription(subscriptionUpdate: $subscriptionUpdate) {
      hasFreePostcard
    }
  }
`;

const UPDATE_RANDOM_TEMPLATE = gql`
  mutation savUpdateRandomTemplates {
    savUpdateRandomTemplates
  }
`;

const UPDATE_TEMPLATE_SUBCATEGORY = gql`
  mutation savUpdateSubCategory($subCategory: SavTemplateSubCategoryInput!) {
    savUpdateSubCategory(subCategory: $subCategory) {
      _id
      titleFr
      titleEn
      presentation
      isExcludeRandom
    }
  }
`;

const UPDATE_LOVEBOX_EMAIL_PHOTOBOOK = gql`
  mutation savLinkLoveBoxAccount($loveboxEmail: String!, $customerEmail: String!, $previousLoveboxEmail: String) {
    savLinkLoveBoxAccount(loveboxEmail: $loveboxEmail, customerEmail: $customerEmail, previousLoveboxEmail: $previousLoveboxEmail)
  }
`;

const GENERATE_PHOTOBOOKS = gql`
  mutation savGeneratePhotoBooks($startDate: String!, $endDate: String!, $limit: Int!, $offset: Int!, $gelatoOrdersDate: String!) {
    savGeneratePhotoBooks(startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset, gelatoOrdersDate: $gelatoOrdersDate)
  }
`;
const GENERATE_PHOTOBOOK_FOR_USER = gql`
  mutation savCreatePhotoBookForUser($startDate: String!, $endDate: String!, $email: String!) {
    savCreatePhotoBookForUser(startDate: $startDate, endDate: $endDate, email: $email)
  }
`;

const SEND_PHOTOBOOKS = gql`
  mutation savSendPhotoBooks($orders: [JSON]!) {
    savSendPhotoBooks(orders: $orders)
  }
`;

const UPDATE_CHANNEL = gql`
  mutation savUpdateChannel($channelId: String!, $updatedChannel: SavUpdateChannelInput!) {
    savUpdateChannel(channelId: $channelId, updatedChannel: $updatedChannel) {
      _id
      nameFr
      nameEn
      description
      AIPrompt
      defaultBackground
      generatedMessageFontSize
      generatedMessageColor
      generatedMessageMarginRight
      generatedMessageMarginLeft
      generatedMessageMarginBottom
      generatedMessageMarginTop
      generatedMessageFontFamily
      premium
      hidden
      spicy
    }
  }
`;

const CREATE_CHANNEL = gql`
  mutation savCreatehannel($channel: SavChannelInput!) {
    savCreateChannel(channel: $channel) {
      _id
      nameFr
      nameEn
      description
      AIPrompt
      defaultBackground
      generatedMessageFontSize
      generatedMessageColor
      generatedMessageMarginRight
      generatedMessageMarginLeft
      generatedMessageMarginBottom
      generatedMessageMarginTop
      generatedMessageFontFamily
      premium
      hidden
      spicy
    }
  }
`;

const CREATE_CHANNEL_MESSAGE = gql`
  mutation SavCreateChannelMessage($channelId: String!, $channelMessage: SavChannelMessageInput!) {
    savCreateChannelMessage(channelId: $channelId, channelMessage: $channelMessage) {
      _id
      channelId
      name
      urlFr
      urlEn
    }
  }
`;

const CREATE_CHANNEL_MESSAGES = gql`
  mutation SavCreateChannelMessages($channelId: String!, $channelMessages: [SavChannelMessageInput!]) {
    savCreateChannelMessages(channelId: $channelId, channelMessages: $channelMessages) {
      _id
      channelId
      urlFr
      urlEn
    }
  }
`;

const DELETE_CHANNEL_MESSAGE = gql`
  mutation SavDeleteChannelMessage($channelMessageId: String!) {
    savDeleteChannelMessage(channelMessageId: $channelMessageId) {
      _id
    }
  }
`;

const DELETE_CHANNEL = gql`
  mutation savDeleteChannel($channelId: String!) {
    savDeleteChannel(channelId: $channelId)
  }
`;

const DELETE_ALL_CHANNEL_MESSAGES = gql`
mutation savDeleteAllChannelMessages($channelId: String!) {
  savDeleteAllChannelMessages(channelId: $channelId)
}
`;

const EDIT_AI_CHANNEL_MESSAGE_TEXT = gql`
  mutation savEditAIChannelMessageText($channelMessageId: String!, $text: String!) {
    savEditAIChannelMessageText(channelMessageId: $channelMessageId, text: $text) {
      _id
      thumbnailEn
    }
  }
`;

const APPLY_COLOR_BATCH = gql`
  mutation savApplyColorBatch($macAddresses: [String!]!, $target: SavColorBatchTarget!) {
    savApplyColorBatch(macAddresses: $macAddresses, target: $target) {
      matchedCount
      modifiedCount
      convertedMacs
      after {
        ...SavColorBatchPreviewFields
      }
    }
  }
  ${COLOR_BATCH_PREVIEW_FIELDS}
`;

export {
  ADD_TEST_BOXES,
  CLEAR_BOX,
  MODERATE_STICKER,
  MODERATE_GIF,
  ACCEPT_ALL_GIFS,
  RESET_USER_PASSWORD,
  SET_GIF_RANK,
  SET_GIF_DESIGNER_RANK,
  SET_GIF_AUTO_RELEASE_DATE,
  EDIT_AI_CHANNEL_MESSAGE_TEXT,
  GET_DISCOUNT_CODE,
  REFRESH_PAIRING_CODE,
  DELETE_SENDERS,
  DELETE_SENDER,
  GET_FREE_HEART_CODE,
  DELETE_USER,
  SET_GIF_TAGS,
  CREATE_TAG,
  UPDATE_TAG,
  DELETE_TAG,
  SEND_IMAGE_TO_LOVEPIX,
  ADD_AMBASSADOR,
  RM_AMBASSADOR,
  DELETE_DUPLICATED_BOX,
  REMOVE_TEST_BOX,
  SET_TARGET_VERSION_TO_TEST_GROUP,
  SET_TARGET_VERSION_TO_BOX,
  CREATE_FIRMWARE_RELEASE,
  SET_FIRMWARE_RELEASE_LIMIT,
  UPDATE_FIRMWARE_RELEASE_STATUS,
  TOGGLE_COLOR_FEATURE,
  CHECK_COLOR_CODE,
  DELETE_FIRMWARE_RELEASE,
  SET_FIRMWARE_RELEASE_ACTIVE,
  SET_FACTORY_SETTINGS_COLOR,
  TRANSFER_BOX_HISTORY,
  SET_FACTORY_SETTINGS_COMPANY_ID,
  SET_FACTORY_SETTINGS_SCREEN_TYPE,
  SET_FACTORY_SETTINGS_PCB_VERSION,
  FACTORY_UNREGISTER_BOXES,
  UPDATE_BOX_ADMIN,
  DELETE_MESSAGE,
  UPDATE_PRIVACY_POLICY,
  CREATE_TEMPLATE,
  UPDATE_TEMPLATE,
  DELETE_TEMPLATE,
  UPDATE_TEMPLATE_CATEGORIES,
  UPDATE_TEMPLATES_RANK,
  DELETE_TEMPLATE_CATEGORY,
  UPDATE_SUBSCRIPTION,
  UPDATE_TEMPLATE_CATEGORY,
  UPDATE_RANDOM_TEMPLATE,
  UPDATE_TEMPLATE_SUBCATEGORY,
  UPDATE_LOVEBOX_EMAIL_PHOTOBOOK,
  GENERATE_PHOTOBOOKS,
  GENERATE_PHOTOBOOK_FOR_USER,
  SEND_PHOTOBOOKS,
  UPDATE_CHANNEL,
  CREATE_CHANNEL,
  CREATE_CHANNEL_MESSAGE,
  DELETE_CHANNEL_MESSAGE,
  CREATE_CHANNEL_MESSAGES,
  CREATE_TEMPLATES,
  DELETE_CHANNEL,
  DELETE_ALL_CHANNEL_MESSAGES,
  GIVE_FREE_LBE,
  TOGGLE_CRAZY_HEART_FIRMWARE,
  GIVE_LOVECOINS,
  APPLY_COLOR_BATCH,
};



// WEBPACK FOOTER //
// ./src/mutation/mutation.js